<template>
  <v-container v-if="!dismissed" class="app-banner" fluid>
    <v-row
      align="start"
      class="app-banner-content"
      justify="space-between"
    >
      <!-- Left Icon + Text -->
      <v-col cols="11" class="d-flex">
        <v-icon class="app-banner-icon" color="#1e355f" size="24">
          {{ mdiAlertCircle }}
        </v-icon>
        <div class="app-banner-text">
          NHB officers will never ask you to transfer money or disclose bank log-in details over a phone call.
          Call the 24/7 ScamShield Helpline at 1799 if you are unsure if something is a scam.
          For more information on how to protect yourself against scams, please visit
          <a
            href="https://www.scamshield.gov.sg"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.scamshield.gov.sg.
          </a>
        </div>
      </v-col> 

      <!-- Close Icon -->
      <v-col cols="1" class="d-flex justify-end">
        <v-btn
          icon
          small
          class="app-banner-close"
          aria-label="Dismiss banner"
          @click="dismissed = true"
        >
          <v-icon color="#333" size="24">{{ mdiClose }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { mdiAlertCircle, mdiClose } from '@mdi/js'

@Component
export default class AppBanner extends Vue {
  mdiAlertCircle = mdiAlertCircle
  mdiClose = mdiClose
  dismissed = false
}
</script>

<style lang="scss" scoped>
.app-banner {
  background-color: #eef2fc;
  padding: 13px 17px !important;
  border-radius: 6px;

  &-content {
    flex-wrap: nowrap;

    @media (max-width: 600px) {
      flex-wrap: wrap;
    }
  }

  &-icon {
    // color: #1e355f;
    border-radius: 50%;
    padding: 2px;
    // font-size: 24px !important;
    margin-right: 0.75rem;
    flex-shrink: 0;
    align-self: flex-start;

    @media (max-width: 600px) {
      margin-bottom: 0.5rem;
    }
  }

  &-text {
    color: #333;
    font-size: 14px;
    line-height: 1.6;

    a {
      color: #1e355f;
      font-weight: 600;
      text-decoration: underline;
    }

    @media (max-width: 600px) {
      font-size: 12px;
    }
  }

  &-close {
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #000;
    }
  }
}
</style>
